import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IUser } from '../../models/settings.models';
import { combineLatest, map, Observable, of, startWith } from 'rxjs';
import { FormControl } from '@angular/forms';
import { AppState } from 'src/app/core/app.state';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-add-recipient',
  templateUrl: './add-recipient.component.html',
  styleUrls: ['./add-recipient.component.scss']
})
export class AddRecipientComponent implements OnInit {

  filteredUsers$!: Observable<IUser[]>;
  users$ = this.store.select((state) => state.settings.users);
  userControl = new FormControl();
  userSelected!: IUser
  constructor(
    public dialogRef: MatDialogRef<AddRecipientComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IUser[],
    private store: Store<AppState>,
  ) { }

  ngOnInit(): void {
    this.filteredUsers$ = combineLatest([
      this.users$,
      of(this.data),
      this.userControl!.valueChanges.pipe(startWith('')),
    ]).pipe(
      map(([users, data, input]) => {
        const normalizedInput = this._normalizeValue(input || '');
    
        // Get IDs from data array
        const dataIds = new Set(data.map(d => d.id));
    
        // Filter users: not in data AND match name or email
        return users.filter(user =>
          !dataIds.has(user.id) &&
          this._matchNameOrEmail(user, normalizedInput!)
        );
      })
    );
  }

  private _matchNameOrEmail(user: any, value: string): boolean | undefined {
    return (
      this._normalizeValue(user.name)?.includes(value) ||
      this._normalizeValue(user.email)?.includes(value)
    );
  }
  private _normalizeValue(value: string | undefined): string | undefined {
    return value?.toLowerCase().replace(/\s/g, '');
  }

  onUserSelected(user: IUser) {
    if(user){
      this.userSelected = user
    }
  }

  save(): boolean | void{
    if(this.userSelected){
      this.dialogRef.close(this.userSelected)
    }
    return false
  }

  closed(){
    this.dialogRef.close()
  }

}
